export const GET_INBOX_REQUEST = 'WORKFLOW/GET_INBOX_REQUEST';
export const GET_INBOX_SUCCESS = 'WORKFLOW/GET_INBOX_SUCCESS';
export const GET_INBOX_ERROR = 'WORKFLOW/GET_INBOX_ERROR';

export const GET_REQUEST_REQUEST = 'WORKFLOW/GET_REQUEST_REQUEST';
export const GET_REQUEST_SUCCESS = 'WORKFLOW/GET_REQUEST_SUCCESS';
export const GET_REQUEST_ERROR = 'WORKFLOW/GET_REQUEST_ERROR';

export const DECIDE_REQUEST = 'WORKFLOW/DECIDE_REQUEST';
export const DECIDE_SUCCESS = 'WORKFLOW/DECIDE_SUCCESS';
export const DECIDE_ERROR = 'WORKFLOW/DECIDE_ERROR';

export const GET_AWAITING_REQUEST = 'WORKFLOW/GET_AWAITING_REQUEST';
export const GET_AWAITING_SUCCESS = 'WORKFLOW/GET_AWAITING_SUCCESS';
export const GET_AWAITING_ERROR = 'WORKFLOW/GET_AWAITING_ERROR';
